import React from 'react';

interface BarSimpleProps {
  data?: any[];
  xKey: string;
  yKey: string;
  height?: number;
}

// Minimal dependency-free horizontal bar chart using divs
const BarSimple: React.FC<BarSimpleProps> = ({ data, xKey, yKey, height = 300 }) => {
  const arr = Array.isArray(data) ? data : [];
  const max = Math.max(1, ...arr.map((d) => Number(d[yKey] || 0)));
  const items = arr.slice(0, 10);
  return (
    <div style={{ width: '100%', height }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxHeight: height, overflow: 'auto' }}>
        {items.map((d, i) => {
          const val = Number(d[yKey] || 0);
          const pct = Math.max(0, Math.min(100, (val / max) * 100));
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ width: 80, fontSize: 12, color: '#666', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }} title={String(d[xKey])}>
                {String(d[xKey])}
              </div>
              <div style={{ flex: 1, background: '#eee', height: 18, borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: pct + '%', height: '100%', background: '#4f46e5' }} />
              </div>
              <div style={{ width: 100, textAlign: 'right', fontSize: 12 }}>
                ${val.toLocaleString()}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BarSimple;
